import { atom } from 'nanostores';

type EmbedVideoModalOptions = {
  embedVideoUrl: string;
} | null;

export const $embedVideoModalOptions = atom<EmbedVideoModalOptions | null>(null);

export const openEmbedVideoModal = (options: EmbedVideoModalOptions) => {
  $embedVideoModalOptions.set(options);
  if (options) {
    window.history.pushState({}, '');
  }
};

export const closeEmbedVideoModal = () => {
  $embedVideoModalOptions.set(null);
  window.history.back();
};
